import { Component } from '@angular/core';

@Component({
	selector: 'app-slider-showcase',
	templateUrl: './slider-showcase.component.html',
	styleUrls: ['./slider-showcase.component.scss'],
	standalone: false,
})
export class SliderShowcaseComponent {
	basicValue: number = 50;
	noInputValue: number = 75;
	blockedFromValue: number = 2500;
	blockedToValue: number = 75;
	blockedBothValue: number = 50;
	iconValue: number = 30;
	validatedValue: number = 0;
	disabledValue: number = 60;
	loadingValue: number = 40;
	percentageValue: number = 50;
	pollutionValue: number = 50;

	validationValid = false;

	validationRules = [
		{
			ruleId: 'required',
			validate: (v: number) => v > 0,
			errorMessage: 'Value must be greater than 0',
		},
	];

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}

	onSliderChange(type: string, value: number): void {
		if (type === 'basic') this.basicValue = value;
		else if (type === 'noInput') this.noInputValue = value;
		else if (type === 'blockedFrom') this.blockedFromValue = value;
		else if (type === 'blockedTo') this.blockedToValue = value;
		else if (type === 'blockedBoth') this.blockedBothValue = value;
		else if (type === 'icon') this.iconValue = value;
		else if (type === 'validated') this.validatedValue = value;
		else if (type === 'disabled') this.disabledValue = value;
		else if (type === 'loading') this.loadingValue = value;
		else if (type === 'percentage') this.percentageValue = value;
		else if (type === 'pollution') this.pollutionValue = value;
	}
}
